import { useCallback } from 'react';
import { Colors, Flex, IconChevronDown, Typography } from '@banhala/ui-kit';
import type { HeadlineSelectableOneLineProps } from './types';
import { bridge, isNil, isNotNil } from '../../../../utils';
import { useOpenDeeplink } from '../../../../hooks';
import { ViewAllButton } from '../ViewAllButton';
import type { IScreensLogging } from '../../../../api/types';

export const HeadlineSelectableOneLine = ({
  header,
  screen,
}: HeadlineSelectableOneLineProps) => {
  const { openDeeplink } = useOpenDeeplink();

  const handlePressMore = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logClickMore({ logging: header.logging, screen });
    openDeeplink(header.item.deeplink);
  }, [header, screen, openDeeplink]);

  const handlePressFilter = useCallback(() => {
    if (isNil(header)) return;
    bridge.logAnalyticsEvent({
      name: 'CLICK_HEADLINE_SELECTABLE_ONE_LINE_FILTER',
      analytics: { ...header.logging.analytics, ...(screen != null && { SCREEN: screen }) },
      ably_only_log: header.logging.ably_only_log,
    });
    // TODO: 필터 BottomSheet 연동
  }, [header, screen]);

  if (isNil(header)) return null;

  const paddingTop = header.item.padding_top ?? 24;
  const paddingBottom = header.item.padding_bottom ?? 16;
  const hasDeeplink = isNotNil(header.item.deeplink);

  return (
    <Flex.Row
      padding={{ top: paddingTop, bottom: paddingBottom, left: 16, right: hasDeeplink ? 0 : 16 }}
      alignItems="center"
    >
      <Flex.Row flex={1} alignItems="center" gap={4}>
        {isNotNil(header.item.selected_value) && (
          <Flex.Row
            alignItems="center"
            gap={2}
            onPress={handlePressFilter}
          >
            <Typography type="h5" color="content_pink_primary">
              {header.item.selected_value.name}
            </Typography>
            <IconChevronDown size={16} fill={Colors.content_pink_primary} />
          </Flex.Row>
        )}
        <Typography type="h5" color="content_primary">
          {header.item.title}
        </Typography>
        {isNotNil(header.item.postfix) && (
          <Typography type="h5" color="content_primary">
            {header.item.postfix}
          </Typography>
        )}
      </Flex.Row>

      {hasDeeplink && (
        <Flex padding={{ right: 4 }}>
          <ViewAllButton onPress={handlePressMore} />
        </Flex>
      )}
    </Flex.Row>
  );
};

const logClickMore = ({ logging, screen }: { logging: IScreensLogging; screen?: string }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_SELECTABLE_ONE_LINE_MORE',
    analytics: { ...logging.analytics, ...(screen != null && { SCREEN: screen }) },
    ably_only_log: logging.ably_only_log,
  });
};
